import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-travelers-by-user',
  templateUrl: './travelers-by-user.component.html',
  styleUrls: ['./travelers-by-user.component.css']
})
export class TravelersByUserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
